import React from 'react';
import styled from 'styled-components';

import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import SkypassFooterHeader from '@ecp/fo/sites/skypass/components/footer/SkypassFooterHeader';
import SkypassFooterBottom from '@ecp/fo/sites/skypass/components/footer/SkypassFooterBottom';

export default function SkypassFooter() {
  return (
    <Container>
      <HorizontalDivider width={'100%'} />
      <SkypassFooterHeader />
      <HorizontalDivider width={'100%'} />
      <Spacing top={20} />
      <SkypassFooterBottom />
    </Container>
  );
}

const Container = styled(FlexBoxColumn)`
  width: 100%;
  height: 327px;
  margin-top: 80px;
`;
